import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React, {
  Component,
} from 'react';
import Select from 'react-select';
import Directives from '../../../Directives/Directives';
import generalClasses from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  ISearchSelectField,
} from '../formFields';
import classes from './searchSelect.module.scss';

interface IProps extends ISearchSelectField {
  errors: any;
  touched: any;

  onChange(prop: any, value: any): any;
}

class SearchSelectField extends Component<IProps> {
  customEditorClassName = {
    maxHeight: 300,
    overflow: 'auto',
    border: '1px solid #dadada',
    minHeight: 100,
    padding: '0 10px',
  };

  render() {
    return (
      <FormControl className={generalClasses.filed}>
        <div className={classNames(classes.richContainer)}>
          <Typography variant="caption" gutterBottom className={classNames(classes.label)}>
            {this.props.label}
          </Typography>
          <Select
            classes={classes.singleSelect}
            inputId="react-select-single"
            TextFieldProps={{
              label: 'Select Article',
              InputLabelProps: {
                htmlFor: 'react-select-single',
                shrink: true,
              },
            }}
            placeholder="Select"
            options={this.props.selectList}
            value={this.props.value}
            onChange={(value: any) => { this.props.onChange(this.props.name, value); }}
          />
        </div>
        <Directives dIf={this.props.errors[this.props.name] && this.props.touched[this.props.name]}>
          <FormHelperText className={generalClasses.error}>{this.props.errors[this.props.name]}</FormHelperText>
        </Directives>
      </FormControl>
    );
  }
}

export default SearchSelectField;
